<mtx-grid [columns]="columns"
          [data]="items"
          [loading]="loading"
          [rowClassFormatter]="rowClassFormatter"
          [showColumnMenuButton]="false"
          [showToolbar]="true"
          [toolbarTemplate]="toolbarTpl"
          [trackBy]="trackByName"
          class="bg-white"
          sortActive="expires_at"
          sortDirection="desc"
          sortStart="desc">
</mtx-grid>

<ng-template #toolbarTpl>
  <div class="flex items-center justify-between">
    <div class="mat-title-large">{{ 'zip_manager.zip_history_table.title' | transloco }}</div>
    <div>
      <mat-form-field subscriptSizing="dynamic">
        <mat-icon matPrefix>filter_alt</mat-icon>
        <mat-label>{{ 'zip_manager.zip_history_table.search_by_name' | transloco }}</mat-label>
        <input [formControl]="filterByNameControl" matInput/>
        @if (filterByNameControl.value) {
          <button matSuffix mat-icon-button (click)="filterByNameControl.setValue('')">
            <mat-icon>clear</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
  </div>
</ng-template>

<ng-template #imageIndexTpl let-col="colDef" let-index="index" let-row>
  <button (click)="detail.emit(row)"
          class="w-full flex gap-2 py-1 overflow-auto">@for (image of row.images; track image.filename) {
    <img class="history-img" [src]="image.image"/>
  }</button>
</ng-template>

<ng-template #expiresAtTpl let-col="colDef" let-index="index" let-row>
  {{ selectExpiration(row.expires_at) | async }}
</ng-template>

<ng-template #nameTpl let-col="colDef" let-index="index" let-row>
  <span [title]="row.name">{{ row.name | shorten: 30 }}</span>
</ng-template>
